import toast from "react-hot-toast";


export const buildPermissionMap = (permissions = []) => {
    const map = new Map();

    for (const p of permissions) {
        const elementKey = p.element?.toLowerCase();
        if (!elementKey) continue;

        const rightSet = new Set();

        for (const r of p.right || []) {
            if (r.hasRight) {
                rightSet.add(r.rightName);
            }
        }

        map.set(elementKey, rightSet);
    }

    return map;
};

export const hasRight = (
    permissionMap,
    element,
    rightName,
    showToast = true
) => {
    if (!(permissionMap instanceof Map)) {
        if (showToast) toast.error("Permissions not initialized!");
        return false;
    }

    const rights = permissionMap.get(element.toLowerCase());

    if (!rights) {
        if (showToast) toast.error(`No permission for ${element}.`);
        return false;
    }

    const hasRight = rights.has(rightName);

    if (!hasRight && showToast) {
        toast.error(`You don't have ${rightName} right for ${element}.`);
    }

    return hasRight;
};

export const hasPermission = (
    permissions, 
    element, 
    rightName, 
    showToast = true
) => {
    if (!Array.isArray(permissions)) {
        if (showToast) toast.error("Permissions not found!");
        return false;
    }

    const permission = permissions.find(p => 
        p.element?.toLowerCase() === element.toLowerCase()
    );

    if (!permission) {
        if (showToast) toast.error(`No permission for ${element}.`);
        return false;
    }

    const right = permission.right?.some(r => r.rightName === rightName && r.hasRight);
    if (!right && showToast) toast.error(`You don't have ${rightName} right for ${element}.`);

    return right;
};
